var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#258E61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94873 23.6837C7.94873 23.3537 8.20873 22.9937 8.62748 22.9937H10.9362C12.2362 22.9937 13.4062 23.8637 13.4062 25.5312C13.4062 27.1112 12.2362 27.9912 10.9362 27.9912H9.26748V29.3112C9.26748 29.7512 8.98748 29.9999 8.62748 29.9999C8.29748 29.9999 7.94873 29.7512 7.94873 29.3112V23.6837ZM9.26748 24.2524V26.7424H10.9362C11.6062 26.7424 12.1362 26.1512 12.1362 25.5312C12.1362 24.8324 11.6062 24.2524 10.9362 24.2524H9.26748Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3638 30C15.0338 30 14.6738 29.82 14.6738 29.3812V23.7037C14.6738 23.345 15.0338 23.0837 15.3638 23.0837H17.6526C22.2201 23.0837 22.1201 30 17.7426 30H15.3638ZM15.9938 24.3037V28.7812H17.6526C20.3513 28.7812 20.4713 24.3037 17.6526 24.3037H15.9938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7399 24.3838V25.9725H26.2886C26.6486 25.9725 27.0086 26.3325 27.0086 26.6813C27.0086 27.0113 26.6486 27.2813 26.2886 27.2813H23.7399V29.38C23.7399 29.73 23.4911 29.9988 23.1411 29.9988C22.7011 29.9988 22.4324 29.73 22.4324 29.38V23.7025C22.4324 23.3438 22.7024 23.0825 23.1411 23.0825H26.6499C27.0899 23.0825 27.3499 23.3438 27.3499 23.7025C27.3499 24.0225 27.0899 24.3825 26.6499 24.3825H23.7399V24.3838Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.4a60b5aa03903cc7610e2ab8f7cddaa9.svg";
export { ForwardRef as ReactComponent };